// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dailyitems/mark_daily_item.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.MarkDailyItemRequest
 */
export class MarkDailyItemRequest extends Message<MarkDailyItemRequest> {
  /**
   * The ID of the daily item to Mark
   *
   * @generated from field: int32 id = 1;
   */
  id = 0;

  constructor(data?: PartialMessage<MarkDailyItemRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MarkDailyItemRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkDailyItemRequest {
    return new MarkDailyItemRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkDailyItemRequest {
    return new MarkDailyItemRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkDailyItemRequest {
    return new MarkDailyItemRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MarkDailyItemRequest | PlainMessage<MarkDailyItemRequest> | undefined, b: MarkDailyItemRequest | PlainMessage<MarkDailyItemRequest> | undefined): boolean {
    return proto3.util.equals(MarkDailyItemRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.MarkDailyItemResponse
 */
export class MarkDailyItemResponse extends Message<MarkDailyItemResponse> {
  constructor(data?: PartialMessage<MarkDailyItemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MarkDailyItemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkDailyItemResponse {
    return new MarkDailyItemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkDailyItemResponse {
    return new MarkDailyItemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkDailyItemResponse {
    return new MarkDailyItemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MarkDailyItemResponse | PlainMessage<MarkDailyItemResponse> | undefined, b: MarkDailyItemResponse | PlainMessage<MarkDailyItemResponse> | undefined): boolean {
    return proto3.util.equals(MarkDailyItemResponse, a, b);
  }
}

